import { inject, type InjectionKey } from 'vue'

import type { OperacoesCatalogoRegraDeCalculo } from '../catalogo-regra-de-calculo.tipos'

export const CHAVE_OPERACOES_CATALOGO_REGRA_DE_CALCULO:
InjectionKey<OperacoesCatalogoRegraDeCalculo> = Symbol(
  'operacoes-catalogo-regra-de-calculo',
)

export const usarOperacoesCatalogoRegraDeCalculo = (
): OperacoesCatalogoRegraDeCalculo => {
  const operacoes = inject(CHAVE_OPERACOES_CATALOGO_REGRA_DE_CALCULO)
  if (!operacoes) {
    throw new Error('Catalogo de regra de calculo nao foi instalado')
  }
  return operacoes
}
